import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import { AbstractModel } from '@patsnap/tahiti-core';
import type { Permission } from '../../types';
import type { PermissionModel } from '../permission-model';

@injectable()
export class PermissionModelImpl extends AbstractModel<Permission> implements PermissionModel {
    protected _modelData: Permission = {
        disclosure: false,
        specificationCn: false,
        specificationUs: false,
        specificationEu: false,
        translation: false,
        noveltyCheckReport: false,
        ftoReport: false,
    };
}
